import image1 from '../../../../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_detailed_img_1.webp';
import image2 from '../../../../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_detailed_img_2.webp';
import image4 from '../../../../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_detailed_abovefooter.webp';

import artwork from '../../../../assets/images/art_2.png';
import eoLogoLowJpg from '../../../../assets/images/eologo-low.webp';
import eoLogoJpg from '../../../../assets/images/eologo.webp';

const Data_IndustrialHazardRecognitionProgram = {
  content: (
    <>
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">PROBLEM</h4>

                  <div className="paragraph light-1">
                    <p>
                      Industrial facilities contain constantly changing risks, and many hazards are easy to miss under time
                      pressure. Traditional classroom instruction can explain what to look for, but it does not always prepare
                      trainees to quickly identify hazards while working in an active environment.
                      <br />
                      <br />
                      NORCAT needed a training experience that places learners inside a realistic industrial shop where they
                      can repeatedly practice hazard recognition, make decisions under a timer, and build confidence before
                      entering higher-risk worksites.
                    </p>
                  </div>
                </div>

                <div className="col-lg-6 second-column">
                  <h4 className="heading heading-small light-2">CHALLENGES</h4>

                  <div className="paragraph light-1">
                    <p>
                      The main challenge was balancing realism, guidance, and pace. Trainees needed enough pressure to reflect
                      real-world decision-making, but also enough feedback to understand why a choice was correct or unsafe.
                      <br />
                      <br />
                      The experience also needed to generate useful reporting for trainers, capturing each trainee decision so
                      instructors can identify missing knowledge and focus follow-up coaching where it matters most.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="project-content">
        <div className="project-content-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-large dark-1">
                    A guided hazard hunt that turns awareness into consistent safety habits.
                  </h2>

                  <div className="paragraph dark-1">
                    <p>
                      The Industrial Hazard Recognition Program is an immersive VR training experience that places trainees
                      inside a fully interactive industrial shop with embedded hazards. Learners must inspect the environment,
                      identify risks within a defined time window, and make decisions as conditions evolve.
                      <br />
                      <br />
                      An AI NPC supervisor provides in-the-moment instruction throughout the experience, reinforcing correct
                      choices and explaining why improper choices increase risk. This creates a coaching layer that supports
                      both first-time learners and experienced workers completing refresher training.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image-wrapper">
            <div className="single-image">
              <img src={image1} alt="Hazard Recognition Program project screenshot 7" loading="lazy" decoding="async" />
            </div>
            <div className="single-image">
              <img src={image2} alt="Hazard Recognition Program project screenshot 8" loading="lazy" decoding="async" />
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-medium dark-1">Structured Practice for Safer Decision-Making</h2>

                  <div className="paragraph dark-1">
                    <p>
                      The program is designed to be repeatable and scalable for internal training teams. Sessions can be run
                      consistently, reviewed in detail, and adapted as procedures evolve.
                    </p>
                  </div>

                  <div className="text-list text-list-with-dashes medium dark-1">
                    <ul>
                      <li>Timed industrial hazard identification scenarios</li>
                      <li>AI NPC supervisor guidance and corrective coaching</li>
                      <li>Immediate reinforcement for correct decisions</li>
                      <li>Decision-level trainee reporting for trainer review</li>
                      <li>Practical support for onboarding and refresher training</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image">
            <img src={image4} alt="Hazard Recognition Program project screenshot 9" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>

      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">RESULTS</h4>

                  <div className="paragraph light-1">
                    <p>
                      The Industrial Hazard Recognition Program gives trainers a practical way to reinforce hazard awareness in
                      a realistic but controlled environment. Trainees gain experience spotting risks under pressure while
                      receiving guided feedback that improves both confidence and consistency.
                      <br />
                      <br />
                      With clear reporting after each run, trainers can hold more focused debriefs and directly target gaps in
                      understanding to strengthen safety performance across teams.
                    </p>
                  </div>
                </div>

                <div className="col-lg-5 offset-lg-1 second-column">
                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">PLATFORM</h4>
                    <div className="paragraph light-1">
                      <p>PC VR</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">CLIENT</h4>
                    <div className="paragraph light-1">
                      <p>NORCAT (Internal)</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">ONLINE</h4>
                    <div className="paragraph light-1">
                      <p>
                        <a href="https://www.norcat.org" target="_blank" rel="noreferrer">
                          www.norcat.org
                        </a>
                      </p>
                    </div>
                  </div>

                  <div className="content-wrapper eo-acknowledgement">
                    <picture>
                      <source media="(max-width: 1024px)" srcSet={eoLogoLowJpg} />
                      <img className="eo-logo-primary" src={eoLogoJpg} alt="This Employment Ontario initiative is funded in part by the Government of Canada and the Government of Ontario." loading="lazy" decoding="async" />
                    </picture>
                    <p>
                      This{' '}
                      <a href="https://www.ontario.ca/page/employment-ontario" target="_blank" rel="noreferrer">
                        Employment Ontario
                      </a>{' '}
                      initiative is funded in part by the{' '}
                      <a href="https://www.canada.ca/en.html" target="_blank" rel="noreferrer">
                        Government of Canada
                      </a>{' '}
                      and the{' '}
                      <a href="https://www.ontario.ca/page/government-ontario" target="_blank" rel="noreferrer">
                        Government of Ontario
                      </a>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-content-footer">
            <div className="container">
              <div className="row align-items-lg-center">
                <div className="col-md-6">
                  <h3 className="heading heading-large light-1">
                    Have an idea?
                    <br />
                    Let's explore it together.
                  </h3>
                </div>
                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                  <div className="button-wrapper">
                    <a className="button button-1" href="/Contact">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="artwork artwork-2" aria-hidden="true">
            <img src={artwork} alt="" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>
    </>
  ),
};

export default Data_IndustrialHazardRecognitionProgram;


